import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  setupConfigurationsTitle: {
    defaultMessage: '{index}Destination & Shipment Type',
    id: 'MlGSs3',
    description: 'Title of the Destination & Shipment Type step',
  },
  warehouseLabel: {
    defaultMessage: 'Warehouse',
    id: '28FsVS',
    description: 'Label for readonly Warehouse input on setup configuration step of advance shipping notice',
  },
  warehouseDefaultTitle: {
    defaultMessage: 'Select',
    id: 'Dh/rLM',
    description: 'Default title for the warehouse dropdown',
  },
  poBoxLabel: {
    defaultMessage: 'P.O. Box',
    id: 'L7ZlMi',
    description: 'Label for readonly P.O. Box input on setup configuration step of advance shipping notice',
  },
  shippingTypeLabel: {
    defaultMessage: 'Shipping Type',
    id: 'erA3Zd',
    description: 'Label for readonly Shipping Type input on setup configuration step of advance shipping notice',
  },
  shipmentArrivalDateLabel: {
    defaultMessage: 'Shipment Arrival Date',
    id: 'fx3EvO',
    description: 'Label for readonly Shipment Arrival Date input on setup configuration step of advance shipping notice',
  },
  whichWarehouseSelectionText: {
    defaultMessage: 'Which warehouse are you shipping to?',
    id: 'AKBy+R',
    description: 'Question to user when a user is selecting a Warehouse to ship to in advance shipping notice',
  },
  selectWarehouseLabel: {
    defaultMessage: 'Select Warehouse',
    id: 'MsadFe',
    description: 'Label for editing the Select Warehouse input on setup configuration step of advance shipping notice',
  },
  purchaseOrderNumberInputLabel: {
    defaultMessage: 'P.O. Number',
    id: 'ojR7wc',
    description: 'Label for edit P.O. Number input on setup configuration step of advance shipping notice',
  },
  selectShippingTypeLabel: {
    defaultMessage: 'Select the shipment type you expect to use.',
    id: 'hOll6G',
    description: 'Label for edit Shipping Type input on setup configuration step of advance shipping notice',
  },
  selectShippingTypeInfo: {
    defaultMessage: 'Select the type of shipping you will be using for this shipment',
    id: 'VBo/0a',
    description: 'Tooltip for shipping type selection',
  },
  checklistLabelParcel: {
    defaultMessage: 'Parcel',
    id: 'NfDrdn',
    description: 'Label for Parcel in the shipping type checklist',
  },
  checklistCaptionParcel: {
    defaultMessage: 'Small, individual packages for lightweight shipments.',
    id: 'CVrlXa',
    description: 'Caption for Parcel in the shipping type checklist',
  },
  checklistLabelPalletizedContainer: {
    defaultMessage: 'Palletized container (LTL)',
    id: 'BTs0lK',
    description: 'Label for Palletized Container in the shipping type checklist',
  },
  checklistCaptionPalletizedContainer: {
    defaultMessage: 'Products arranged on pallets, typically for bulk shipments including both full or less than a truckload (LTL).',
    id: 'ElI9k3',
    description: 'Caption for Palletized Container in the shipping type checklist',
  },
  checklistLabelFloorLoadedContainer: {
    defaultMessage: 'Floor loaded container (Freight)',
    id: 'xMxF9o',
    description: 'Label for Floor Loaded Container in the shipping type checklist',
  },
  checklistCaptionFloorLoadedContainer: {
    defaultMessage:
      'Items loaded directly onto the container floor, maximizing space for large or irregular shipments. This option is more expensive to receive.',
    id: 'Qcz43A',
    description: 'Caption for Floor Loaded Container in the shipping type checklist',
  },
  required: {
    defaultMessage: 'Required',
    id: 'tYtzEc',
    description: 'Required message to appear under input to alert the user.',
  },
  purchaseOrderNoSpaces: {
    defaultMessage: 'PO# cannot include spaces. Please remove the spaces to continue',
    id: 'xy6TTi',
    description: 'Error message for when the purchase order contains spaces',
  },
  confirmChangePackageTypeHeader: {
    defaultMessage: 'Confirm Edit Destination and Shipment Type ',
    description: 'Header text for confirmation dialogue if user wants to continue updating package type',
    id: 'Ind9PU',
  },
  confirmChangePackageTypeBody: {
    defaultMessage:
      'Are you sure you want to edit your destination and shipment type? <b>Any inputs or selections made in your Define Shipments section will be removed.</b>',
    description: 'Body text for confirmation dialogue if user wants to continue updating package type',
    id: 'B1gAmM',
  },
});
